<template>
  <div class="container-fluid mt--6 dashboard" >
    <div class="filter-show">
        <div class="card w-100 p-2 mb-2  d-inline-block">
          <div class="d-flex bd-highlight">
            <h5 class="mt-2 p-2 flex-grow-1 bd-highlight">Filters</h5>
             <!-- <button @click="getPLList('','download')" type="button" class="pl-export btn btn-warning rounded"><i class="fas fa-file-export"></i> EXPORT</button>               -->
             <div class="mt-2">
              <toggle-button  :sync="true" v-model="highlightMinDenomBreach"/> <label class="mr-2">Highlight MinDenom Breach</label> 
            </div>
             <span class="btn btn-outline-secondary btn-sm rounded" @click="getPLList('','download')">
              <i v-if="!loading" class="fas fa-file-export"></i> 
              <i v-if="loading" class="fa fa-spinner fa-spin"></i> EXPORT
            </span>
            <span class="btn btn-outline-secondary btn-sm rounded" @click="showFilters = !showFilters">
              <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
            </span>
          </div>
          <div class="row" v-if="showFilters">
            <div class="col-lg-12">
              <form class="row">
                <div  class="col-md-2">
                  <label for="filter" class="col-form-label">Settlement From</label>
                  <datepicker v-model="fromDate"  name="fromDate" placeholder="mm/dd/yyyy" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                </div>
                <div  class="col-md-2">
                  <label for="filter" class="col-form-label">Settlement To</label>
                  <datepicker v-model="toDate" placeholder="mm/dd/yyyy"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                </div>
                <div v-if="isAdmin || isSuperAdmin || isEditor" class="col-md-4">
                  <label for="filter" class="col-form-label">Trader</label>
                  <multiselect 
                    v-model="filterTrader" 
                    placeholder="Select traders" 
                    label="firstName" 
                    track-by="traderId"
                    :options="traderList"  
                    :multiple="true" 
                    
                    :limit="3"  ></multiselect>
                </div>
                <div class="col-md-4">
                  <label for="filter" class="col-form-label">Accounts</label>
                  <multiselect 
                    v-model="filterAccounts" 
                    placeholder="Select accounts" 
                    :options="accountList"  
                    :multiple="true" 
                  
                    :limit="3"  ></multiselect>
                </div>
              </form>
              <form class="row">
                <div class="col-md-3">
                  <label for="filter" class="col-form-label">Cusips</label>
                  <multiselect 
                    v-model="filterCusips" 
                    placeholder="Select cusips" 
                    :options="cusipList"
                    :preserve-search="true"  
                    :multiple="true" 
                    :limit="3"  ></multiselect>
                </div>
                 <div class="col-md-3">
                    <label for="filter" class="col-form-label">Rep Codes</label>
                    <multiselect 
                      v-model="filterRepCode" 
                      placeholder="Select rep code" 
                      :options="repCodes"
                      :preserve-search="true"  
                      :multiple="true" 
                      :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-3">
                    <label for="filter" class="col-form-label">Transaction Type</label>
                    <multiselect 
                      v-model="filterTransactionType" 
                      placeholder="Select type" 
                      :options="transactionTypes"
                      :preserve-search="true"  
                      :multiple="true" 
                      :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-3">
                    <div class="form-check mt-5">
                      <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="showMinDenomBreachOnly" >
                      <label for="checkbox2" class="form-check-label">Show min. denom. breach only?</label>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" style="top:12px">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                    <button @click="getPLList()" type="button" class="btn btn-primary rounded">Filter</button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
            <div class="col-xl-12">
              <div class="card vh-75" id="scroll">
                  <div class="table-responsive">
                  <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                  <table class="table align-items-center table-flush table-hover bidtbl">
                      <thead class="thead-light psticky">
                      <tr>
                        <th
                          scope="col" 
                          class="sort text-center"
                        >
                        </th>
                        <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                              @click="sort('cusip')" >CUSIP</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'accountNo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'accountNo'  ? 'sort-desc' : '']"  
                              @click="sort('accountNo')" >ACCOUNT <br> NO</th>
                          <th
                            scope="col" 
                            class="sort text-center"
                            >BUY/SELL </th> 
                            <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tradeDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tradeDate'  ? 'sort-desc' : '']"  
                              @click="sort('tradeDate')" >TRADE <br> DATE</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settlementDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settlementDate'  ? 'sort-desc' : '']"  
                              @click="sort('settlementDate')" >SETTLEMENT <br> DATE</th>
                          
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                              @click="sort('quantity')" >QTY</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                              @click="sort('price')" >PRICE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'principalAmnt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'principalAmnt'  ? 'sort-desc' : '']"  
                              @click="sort('principalAmnt')" >PRINCIPAL <br> AMOUNT</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'interest'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'interest'  ? 'sort-desc' : '']"  
                              @click="sort('interest')" >INTEREST</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'commConcAmount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'commConcAmount'  ? 'sort-desc' : '']"  
                              @click="sort('commConcAmount')" >COMMCON <br> AMOUNT</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'referenceNo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'referenceNo'  ? 'sort-desc' : '']"  
                              @click="sort('referenceNo')" >REF <br> NO</th>  
                          <!-- <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'primaryAcctHolder'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'primaryAcctHolder'  ? 'sort-desc' : '']"  
                              @click="sort('primaryAcctHolder')" >PRIMARY ACCOUNT HOLDER</th> -->
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'acctType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'acctType'  ? 'sort-desc' : '']"  
                              @click="sort('acctType')" >ACCOUNT <br> TYPE</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'execBrokerMinor'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'execBrokerMinor'  ? 'sort-desc' : '']"  
                              @click="sort('execBrokerMinor')" >EXEC <br> BROKER <br>MINOR</th>  
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'execBrokerMinor'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'execBrokerMinor'  ? 'sort-desc' : '']"  
                              @click="sort('securityType')" >Security <br> Type</th>
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'execBrokerMinor'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'execBrokerMinor'  ? 'sort-desc' : '']"  
                              @click="sort('repCode')" >RR1</th>        
                          <th 
                              scope="col" 
                              class="sort text-center border-right"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'fbsiShortName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'fbsiShortName'  ? 'sort-desc' : '']"  
                              @click="sort('fbsiShortName')" >FBSI <br>SHORT <br>NAME</th> 
                          <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settled'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settled'  ? 'sort-desc' : '']"  
                              @click="sort('settled')" >SETTLED</th> 
                          <!-- <th 
                              scope="col" 
                              class="sort text-center"
                              v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                              @click="sort('firstName')" >Trader</th>        -->
                          <th
                            scope="col" 
                            class="sort text-center">
                            ACTION
                          </th>                                     
                        
                      </tr>
                      </thead>
                      <tbody class="list no-cursor">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="data in PlList" :key="data.id" v-bind:class="{'row-highlight-red' : data.highlight}">
                        <td class="text-center">
                          <span v-if="highlightMinDenomBreach && data.isMinDenomIrregular" data-toggle="tooltip" data-placement="left"  title="Irregular Minimum Denomination ">
                            <i class="fa fa-exclamation-triangle" style="color: #ff1b1b; font-size: 13px;"></i>
                          </span>
                        </td>
                        <td class="text-center">
                          <span :class="getClass(data)">
                            <span data-toggle="tooltip" data-placement="left"  title="Below Minimum Denomination" v-if="data.isBelowMinDenom">{{data.cusip}}</span>
                            <span v-if="!data.isBelowMinDenom">{{data.cusip}}</span>
                            </span></td>

                          <td class="text-center">{{data.accountNo}}</td>
                          <td class="text-center">{{data.actionSb}}</td>

                          <td class="text-center">{{moment(data.tradeDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{moment(data.settlementDate).format("MM/DD/YYYY") }}</td>
                          <td class="text-center">{{data.quantity}}</td>
                          <td class="text-center">{{data.price | currency}}</td>
                          <td class="text-center">{{data.principalAmnt | currency}}</td>
                          <td class="text-center">{{data.interest | currency}}</td>
                          <td class="text-center">{{data.commConcAmount | currency}}</td>
                          <td class="text-center">{{data.referenceNo}}</td>
                          <!-- <td class="text-center">{{data.primaryAcctHolder}}</td> -->
                          <td class="text-center">{{data.acctType}}</td>
                          <td class="text-center">{{data.execBrokerMinor}}</td>
                          <td class="text-center">{{data.securityType}}</td>
                          <td class="text-center">{{data.repCode}}</td>
                          <td class="text-center border-right">{{data.fbsiShortName}}</td>
                          <td class="text-center">{{data.settled}}</td>
                          <!-- <td class="text-center">{{data.firstName}}</td> -->
                          <td>
                            <a  @click="editTrade(data)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                            <!-- <button @click="assignTrade(data)" class="btn btn-primary" title="Assign Trader">Assign Trader</button> -->

                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getPLList(currentPage)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
                  </div>
              </div>
              </div>
      </div>
      <edittrade
          v-if="editTradeModalOpen"
          v-bind:tradeData="tradeData"
          @close="closeEditTradePoup()"
      ></edittrade>
      <assigntrade
          v-if="editAssignTradeModalOpen"
          v-bind:tradeData="tradeData"
          @close="closeAssignTradePoup()"
      ></assigntrade>
  </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';
import edittrade from './ImsProfitLossEditTrade.vue'
import assigntrade from './ImsProfitLossAssignTrader.vue'

export default {
  name: "imsPLComponentSells",
  components : {
      Datepicker,
      edittrade,
      assigntrade
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "tradeDate",
        sortOrder: "DESC",
        plModalOpen : false,
        traderList:[],
        PlList:[],
        showFilters : false,
        filterTrader : [],
        sellModalOpen : false,
        sellData : null,
        accountList : [],
        filterAccounts : [],
        cusipList : [],
        filterCusips : [],
        fromDate : "",
        toDate : "",
        repCodes : [],
        filterRepCode : [],
        transactionTypes : ["Trade Profit","Off-Board Transactions","Sales Credit","End of month"],
        filterTransactionType : [],
        tradeData : null,
        editTradeModalOpen : false,
        editAssignTradeModalOpen : false,
        isAdmin : false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        highlightMinDenomBreach : true,
        showMinDenomBreachOnly  : false

    };
  },
  methods: {
    getClass(data) {
      const classObj = {
        'min-denom-below': data.isBelowMinDenom ,
        //'ml-4': !data.isMinDenomIrregular,
        // 'min-denom-both': data.isMinDenomIrregular && data.isBelowMinDenom,
      };
      if(this.highlightMinDenomBreach)
        return classObj;
    },
    getCommissions(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/commissions",
            auth
        )
        .then(result => {
          this.transactionTypes = this.transactionTypes.concat(result.data.map((data) => {return data.commissionName}));
          this.loading = false;

        })        
    },
    closeEditTradePoup(){
      this.editTradeModalOpen = false
      this.getPLList(); 
    },
    closeAssignTradePoup(){
      this.editAssignTradeModalOpen = false
      this.getPLList(); 
    },
    assignTrade(data){
      this.tradeData = data;
      this.tradeData.type = "SELL";
      this.editAssignTradeModalOpen = true;
    },
    editTrade(data){
      this.tradeData = data;
      this.tradeData.type = "SELL";
      this.editTradeModalOpen = true;
    },
    getRepCodeList(currentPage){
      //this.loading = true;
      if (!currentPage) {
      currentPage = 1;
      }
      const auth = {
          headers: { 'org-token' : authService.getOrgToken()  }
      };
      this.$http
      .get(config.baseUrlBidSide + 
          "/pnl/rep-code-list?page=1&size=20&search=&sortColumn=id&sortOrder=DESC",
          auth
      )
      .then((result) => {
          this.repCodes = result.data.content.map((e) => {return e.repCode});
          //this.loading = false;                       
      })
      .catch(() => {
          //this.loading = false;              
      });
    },
    search(){
        
    },
    clearSearch(){
      this.searchValue = "";
       
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getPLList();
    },
    clearFilter(){
      this.filterTrader = [];
      this.filterAccounts = [];
      this.filterCusips = [];
      this.filterRepCode = [];
      this.filterTransactionType = [];
      this.showMinDenomBreachOnly = false
      this.getPLList();
    },
    getPLList(currentPage,download){
      this.loading = true;
      var self = this;
      // if (!currentPage) {
      //   currentPage = 1;
      // }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      var fDate = this.fromDate ? this.moment(this.fromDate).format("YYYY-MM-DD") : "";
      var tDate = this.toDate ? this.moment(this.toDate).format("YYYY-MM-DD") : "";
      var filterTrader =  this.filterTrader.map((e) => {return e.traderId}).toString();
      //if trader only user login only need logged traders data
      if(this.isTrader && !this.isAdmin && !this.isEditor && !this.isSuperAdmin){
        if(authService.getUser().traderId){
          filterTrader = authService.getUser().traderId;
        }
      }
      let url = download ? url = "/pnl/sells-download?cognitoSub="+authService.getUser().cognitoSub :  url = "/pnl/sells";

      this.$http
        .get(
          config.baseUrlBidSide +
            url+"?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate+
            "&traderIds="+
            filterTrader+
            "&accounts="+
            this.filterAccounts.toString()+
            "&cusips="+
            this.filterCusips.toString()+
            "&ignored=false"+
            "&repCode="+
            this.filterRepCode.toString()+
            "&transactionType="+
            this.filterTransactionType.toString()+
            "&highlightMinDenomBreach="+
            this.highlightMinDenomBreach+
            "&showMinDenomBreachOnly="+
            this.showMinDenomBreachOnly,
            auth

        )
        .then(result => {
            this.loading = false;
            if(download){
              window.open(result.data, "_blank");
            }else{
              this.totalRows = result.data.pageInfo.totalElements;
              this.PlList = result.data.content;
            }
        })
        .catch(error => {
          if(error.message.includes("504")){
            self.$fire({
            title: "Download timed out",
            type: 'warning',
            html: 'Please check file logs to download the file.',
            footer: '<a href="/ims/ims-file-logs">Click here to see the file logs</a>'
          })
          }
          self.loading = false;
        });
    },
     getTraderList(){
      this.loading = true;
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/trader-list?page=1&size=100&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group="+this.tenantName+"-Trader",
            auth
        )
        .then(result => {
          this.traderList = result.data.content.filter((e) => {return e.traderId != null});
           if(this.$route.query.traderId){
              this.traderList.forEach(element => {
                if(element.traderId == this.$route.query.traderId){
                  this.filterTrader.push(element);
                }
              });
              this.showFilters = true;
            }
            this.getPLList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    getAccountList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/accounts",
            auth
        )
        .then((result) => {
          this.accountList = result.data;
        })
    },
    getCusipList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/cusips",
            auth
        )
        .then(result => {
          this.cusipList = result.data;
        })
    },
    getLastImportedDate(){
       const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/latest-import-date?cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          if(result.data.from && !this.$route.query.fromdate){
            this.fromDate = result.data.from;
            this.toDate = result.data.to;
            this.showFilters = true;
          }
          this.getTraderList();
        })
    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
            roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
            roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            // this.fromDate = this.moment().format("YYYY-MM-DD");
            // this.toDate = this.moment().add(1,'days').format("YYYY-MM-DD");
            if(this.$route.query.transactionType){
              this.filterTransactionType.push(this.$route.query.transactionType);
              this.showFilters = true;
            }
            if(this.$route.query.repCode){
              this.filterRepCode.push(this.$route.query.repCode);
              this.showFilters = true;
            }
            if(this.$route.query.fromdate){
              this.fromDate = this.$route.query.fromdate
            }
            if(this.$route.query.todate){
              this.toDate = this.$route.query.todate
            }
            this.getLastImportedDate();
            //this.getTraderList();
            //this.getPLList();
            this.getAccountList();
            this.getCusipList();
            this.getRepCodeList();
            this.getCommissions();
          }
        });
        
        
      }
    });
     
  }
};
</script>